import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";
import { bookingMetadataTypes } from "@shared/constants/bookingMetadataTypes";

import { type IBookingMetadata } from "@types";

/** @deprecated Legacy token flow — delete once the bookings emailed by the old bookings service are all done. */
export const BOOKING_METADATA_NON_USER = "bookingMetadataNonUser";
export const bookingMetadataNonUserApi = createApi({
  reducerPath: BOOKING_METADATA_NON_USER,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    postBookingMetadataNonUser: builder.mutation<void, { token: string; metadata: IBookingMetadata["data"] }>({
      query: ({ token, metadata }) => ({
        url: "/booking-metadata-non-user",
        method: "POST",
        body: { type: bookingMetadataTypes.inputMeetingData, data: metadata },
        headers: { [httpHeaders.authToken]: token },
      }),
    }),
  }),
});

/** @deprecated Use `usePostBookingMetadataMagicLinkMutation` — this one carries the legacy application token. */
export const { usePostBookingMetadataNonUserMutation } = bookingMetadataNonUserApi;
